import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { AssetMaintainanceTransactions } from "./asset-maintainance-transactions.entity";
import {AssetStatusEnum} from 'libs/shared-models/common-models/src/lib/enum/asset-status.enum';
import { Assets } from "../../open-assets/open-assets-entity";

@Entity('asset_maintainance')
export class AssetMaintainance{
    @PrimaryGeneratedColumn("increment", {
        name: 'asset_maintainance_id'
    })
    assetMaintainanceId : number;
    
    // @Column("varchar", {
    //     name: 'asset_id'
    // })
    // assetId : string;

    @Column("int", {
        name: 'asset_location_id'
    })
    assetLocationId : number;

    @Column("varchar",{
        name:'asset_condition'
    })
    assetCondition : string;

    @Column("varchar",{
        name:'maintainance_frequency_in_days'
    })
    maintainanceFrequencyInDays : string;

    @Column("varchar",{
        name:'assigned'
    })
    assigned: string;

    @Column("varchar",{
        name:'maintainance_type'
    })
    maintainanceType: string;

    @Column("varchar",{
        name:'owner'
    })
    owner: string;

    @Column({
        name:'expired_date',
        type:'datetime'
    })
    expiredDate : Date;

    @Column("varchar",{
        name:'cost_of_repair'
    })
    costOfRepair:string;

    @Column("varchar",{
        name:'damage_reason'
    })
    damageReason:string;

    @Column("varchar",{
        name:'remarks'
    })
    remarks: string;

    @Column("varchar",{
        name:'status'
    })
    status: AssetStatusEnum;

    @Column("boolean", {
        name: 'is_active',
        default: true
    })
    isActive : boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar",{
        name:'can_be_reused'
    })
    canbeReused:string;

    @Column("varchar", {
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(() => AssetMaintainanceTransactions,(assetMaintainanceTransactions)=> assetMaintainanceTransactions.assetMaintainanceTransactionsId)
    assetMaintainanceTransactions : AssetMaintainanceTransactions[];

    @ManyToOne(() => Assets, (asset) => asset.assetMaintainance)
    @JoinColumn({name: 'asset_id'})
    assetsId: Assets;

}